/** Languages the Mini App ships in (FXM-01 §7: French and English from v1). */
export const supportedLanguages = ['fr', 'en'] as const;

/** One of {@link supportedLanguages}. */
export type SupportedLanguage = (typeof supportedLanguages)[number];

/**
 * Picks the UI language from Telegram's `language_code` (FXM-01 §7: follow the app's language).
 *
 * Any French variant (`fr`, `fr-CA`) gives French; anything else, including no code,
 * gives English. Provisional until Q26 decides whether the trader may override it.
 */
export function resolveLanguage(code?: string): SupportedLanguage {
  return code?.trim().toLowerCase().startsWith('fr') === true ? 'fr' : 'en';
}
